import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/style/reset.css"
import 'swiper/css/swiper.css';
import './assets/style/main.scss';
import hoverScale from './directives/hover-scale';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Icon from "./components/Icon.vue"

import ResizeRefreshPlugin from '../src/uitls/resize-refresh-plugin';
Vue.use(ResizeRefreshPlugin);

Vue.component('Icon', Icon)

// 弹出框的时候滚动条隐藏和出现导致页面抖动问题
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI);

Vue.config.productionTip = false;

// 注册自定义指令
Vue.directive('hover-scale', hoverScale);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')